import React, { useEffect, useState } from "react";
import backArrow from "../../assets/images/back-arrow.png";
import queryString from "query-string";
import analytics from "../../util/analytics";
import Toaster from "../../components/Toaster";
import MultiSteps from "../../components/MultiSteps";
import TopBar from "../../components/multi-step-components/TopBar";
import "./styles.scss";

const MultiStepForm = ({
  location: { search },
  mediaQuery,
  match: { path },
}) => {
  const [userAddress, setUserAddress] = useState("");
  const [refCode, setRefCode] = useState("");
  const [roofType, setRoofType] = useState("");

  const [formStep, setFormStep] = useState(false);
  const [showWelcomeToast, setShowWelcomeToast] = useState(true);

  useEffect(() => {
    analytics.page({
      page: "Multi Step Funnel",
    });
  }, []);

  useEffect(() => {
    setRoofType(path.split("/")[1]);
  }, [path]);

  useEffect(() => {
    if (search) {
      const parsedQueryString = queryString.parse(search);
      const { address, ref } = parsedQueryString;
      setUserAddress(decodeURI(address));
      ref && setRefCode(ref);

      address && address?.trim() && setFormStep(1);

      !address?.trim() && setFormStep(0);
    } else {
      setFormStep(0);
    }
  }, [search]);

  return (
    <>
      <>
        <TopBar roofType={roofType} mediaQuery={mediaQuery} step={formStep} />
        <MultiSteps
          parsedQueryString={queryString.parse(search)}
          step={formStep}
          setStep={setFormStep}
          userAddress={userAddress}
          refCode={refCode}
          roofType={roofType}
        />

        {formStep === 1 && (
          <Toaster
            showToast={showWelcomeToast}
            setShowToast={setShowWelcomeToast}
          />
        )}
        {formStep > 0 && formStep < 5 && (
          <span
            onClick={() => setFormStep(formStep - 1)}
            className="go-back-section"
          >
            <img src={backArrow} alt="Go Back Icon" className="back-arrow" />{" "}
            Back
          </span>
        )}
      </>
    </>
  );
};

export default MultiStepForm;
